import axios, {AxiosPromise} from "axios";

export const initTrackingEvents = () => {
    document.querySelectorAll<HTMLElement>('[data-track-event]').forEach(element => {
        const dataset = element.dataset;
        const event = dataset.trackEvent;
        const id = dataset.trackId;

        if (!event || !id) {
            console.error('Event not configured correctly');
            return;
        }

        trackCommand(dataset.trackNonce, dataset.trackAction, id, event, dataset.trackProperties);
    });

}

const trackCommand = (nonce: string, action: string, email: string, event: string, properties: string): AxiosPromise => {
    let formData = new FormData();
    formData.set('action', 'acp_track_event');
    formData.set('email', email);
    formData.set('event', event);
    formData.set('properties', properties);
    formData.set('nonce', nonce);

   return axios.post(window.location.toString(), formData);
}